<div class="legend-container">
    <nb-accordion>
        <nb-accordion-item>
            <nb-accordion-item-header>Legend</nb-accordion-item-header>
            <nb-accordion-item-body>
                <div
                    *ngFor="let bucket of categoryList; trackBy: trackBy"
                    class="d-flex align-items-center justify-content-between"
                >
                    <div class="d-flex align-items-center mb-2">
                        <span
                            class="colourbox"
                            [ngClass]="{
                                checked: isSelected(bucket),
                                unselected: !isSelected(bucket),
                                'colourbox-checkbox': selectInLegend
                            }"
                            [ngStyle]="getBackgroundColour(bucket.colour, isSelected(bucket))"
                            (click)="toggleSelection(bucket)"
                        ></span>
                        <span class="name">{{ bucket.labelList[0] }}</span>
                    </div>
                    <nb-checkbox
                        *ngIf="selectInLegend"
                        [checked]="isSelected(bucket)"
                        (checkedChange)="toggleSelection(bucket)"
                    ></nb-checkbox>
                </div>
            </nb-accordion-item-body>
        </nb-accordion-item>
    </nb-accordion>
</div>
